module.exports = __webpack_public_path__ + "static/media/coins-tex.283242a6.png";